import { combineReducers } from 'redux';

import { coworkingsByOperator } from './coworkingsByOperator';
import { isOperator } from './isOperator';
import { lkUrlReducer as lkUrl } from './lkUrl';
import { ICoworkingState } from './types';

export const coworkingCombinedReducer = combineReducers<ICoworkingState>({
  coworkingsByOperator,
  isOperator,
  lkUrl,
});
